module.exports = __webpack_public_path__ + "static/media/bird_fly_page9_02.e8069f72.gif";